export default {
  message: state => state.message,
  messages: state => state.messages,
  messageCountsWorkOrder: state => state.messageCountsWorkOrder,
  workOrderMessages: state => state.workOrderMessages,
  messageCategories: state => state.messageCategories
}



// WEBPACK FOOTER //
// ./src/store/modules/messages/getters.js